import { ARRAY_UTILITIES } from "./classes";
export class RANDOM_UTILITIES {
    private static seed: number = 0;


    public static set_seed(seed: number): void {
        RANDOM_UTILITIES.seed = seed;
    }


    public static get_random_decimal_between_zero_and_one(): number {

        RANDOM_UTILITIES.seed = (RANDOM_UTILITIES.seed * 9301 + 49297) % 233280;

        return RANDOM_UTILITIES.seed / 233280;
    }

    /*
    public static get_random_decimal_between_zero_and_one(): number {
        // תפקיד פונקציה זו הוא להחסיר מספר בין 0 ל 1 לא כולל 1
        // תפקיד פונקציה זו הוא להחסיר מספר בין 0 ל 1 לא כולל 1
        // תפקיד פונקציה זו הוא להחסיר מספר בין 0 ל 1 לא כולל 1
        return Math.random();
    } */

    public static get_random_integer_below(supremum: number): number {
        //supremum לא כולל supremum תפקיד פונקציה זו היא להחזיר מספר שלם בין 0 ל
        //supremum לא כולל supremum תפקיד פונקציה זו היא להחזיר מספר שלם בין 0 ל
        //supremum לא כולל supremum תפקיד פונקציה זו היא להחזיר מספר שלם בין 0 ל

        const result: number = Math.floor(Math.random() * supremum);

        if (result < 0 || result >= supremum) {
            alert("INTERNAL ERROR: random number is outside requested range.");
        }

        return result;
    }

    public static get_random_integer_between(minimum: number, maximum: number): number {

        const supremum: number = maximum - minimum + 1;
        const random_integer: number = RANDOM_UTILITIES.get_random_integer_below(supremum);

        const result: number = random_integer + minimum;

        if (result < minimum || result > maximum) {
            alert("INTERNAL ERROR: random number is outside requested range.");
        }

        return result;
    }

    public static get_random_char_between(start_char: string, end_char: string): string {
        const start_char_code: number = start_char.charCodeAt(0);
        const end_char_code: number = end_char.charCodeAt(0);
        const random_char_code: number = RANDOM_UTILITIES.get_random_integer_between(start_char_code, end_char_code);
        const random_char: string = String.fromCharCode(random_char_code);
        return random_char;
    }


    public static get_random_digit_array(number_of_digits: number): number[] {
        const random_digit_array: number[] = [];
        for (let i: number = 0; i < number_of_digits; i++) {
            const random_digit: number = RANDOM_UTILITIES.get_random_integer_between(0, 9);
            random_digit_array.push(random_digit);
        }
        return random_digit_array;
    }


    public static get_random_char_array(number_of_chars: number): string[] {
        const random_char_array: string[] = [];
        for (let i: number = 0; i < number_of_chars; i++) {
            const random_char: string = RANDOM_UTILITIES.get_random_char_between("A", "L");
            random_char_array.push(random_char);
        }
        return random_char_array;
    }

    public static permute_array_by_fisher_yates_algorithm(numbers: number[]): void {
        // clone שים לב שפונקציה זו משנה את הפרמטר שלה. היא לא עובדת על
        // clone שים לב שפונקציה זו משנה את הפרמטר שלה. היא לא עובדת על
        // clone שים לב שפונקציה זו משנה את הפרמטר שלה. היא לא עובדת על

        // chat gpt הקוד נוצר על ידי fisher_yates פונקציה זו מבצעת פרמוטציה באלגוריתם
        // chat gpt הקוד נוצר על ידי fisher_yates פונקציה זו מבצעת פרמוטציה באלגוריתם
        // chat gpt הקוד נוצר על ידי fisher_yates פונקציה זו מבצעת פרמוטציה באלגוריתם
        // chat gpt הקוד נוצר על ידי fisher_yates פונקציה זו מבצעת פרמוטציה באלגוריתם
        for (let i: number = numbers.length - 1; i > 0; i--) {
            const j: number = RANDOM_UTILITIES.get_random_integer_between(0, i);
            const temp: number = numbers[i];
            numbers[i] = numbers[j];
            numbers[j] = temp;
        }
    }

    public static get_permutation_of_clone_of_array_by_fisher_yates_algorithm(numbers: number[]): number[] {
        // clone להזכיך: פונקציה זו עובדת ומחזירה
        // clone להזכיך: פונקציה זו עובדת ומחזירה
        // clone להזכיך: פונקציה זו עובדת ומחזירה
        // clone להזכיך: פונקציה זו עובדת ומחזירה
        // clone להזכיך: פונקציה זו עובדת ומחזירה
        // clone להזכיך: פונקציה זו עובדת ומחזירה
        const clone: number[] = [...numbers];
        RANDOM_UTILITIES.permute_array_by_fisher_yates_algorithm(clone);
        return clone;
    }

    public static get_and_remove_random_element_from_array_of_numbers(array_of_numbers: number[]): number {

        const random_index: number = RANDOM_UTILITIES.get_random_integer_below(array_of_numbers.length);
        const result: number = array_of_numbers[random_index];
        array_of_numbers.splice(random_index, 1);
        return result;
    }

    public static get_random_elements_from_array(array_of_numbers: number[], number_of_elements: number): number[] {

        const clone_array: number[] = [...array_of_numbers];
        const result_array: number[] = [];
        for (let i: number = 0; i < number_of_elements; i++) {
            const random_element: number = RANDOM_UTILITIES.get_and_remove_random_element_from_array_of_numbers(clone_array);
            result_array.push(random_element);
        }
        return result_array;
    }


    public static get_random_indexes_of_array_of_numbers(array_of_numbers: number[], number_of_indexes: number): number[] {
        const array_of_indexes = ARRAY_UTILITIES.get_array_of_sequential_numbers_start_from_zero(array_of_numbers.length);
        return RANDOM_UTILITIES.get_random_elements_from_array(array_of_indexes, number_of_indexes);
    }
}
